import type {LocationQueryValue, RouteLocationNormalizedLoaded, Router} from "vue-router";

export function allStringValues(
    value: string | null | undefined | (string | null | undefined)[]
): string[] {
    if (!value) {
        return []
    } else if (Array.isArray(value)) {
        return value.filter((v) => !!v) as string[]
    } else {
        return [value]
    }
}

export function firstStringValue(
    value: string | null | undefined | (string | null | undefined)[]
): string | undefined {
    if (!value) {
        return undefined
    } else if (Array.isArray(value)) {
        return value[0] as string | undefined
    } else {
        return value as string
    }
}

export function firstIntValue(
    value: string | null | undefined | (string | null | undefined)[]
): number | undefined {
    const string = firstStringValue(value)
    const number = string ? parseInt(string) : undefined
    return Number.isNaN(number) ? undefined : number
}

const BOOLEAN_FALSE_VALUES = ["false", "no", "0"]

export function firstBooleanValue(
    value: string | null | undefined | (string | null | undefined)[]
): boolean | undefined {
    const string = firstStringValue(value)
    return string ? (string.length > 0 && !BOOLEAN_FALSE_VALUES.includes(string)) : undefined
}

export function updateQuery(
  router: Router,
  route: RouteLocationNormalizedLoaded,
  query: Record<string, LocationQueryValue | LocationQueryValue[] | undefined>
) {
  router.push({
    ...route,
    query: {
      ...route.query,
      ...query,
    },
  })
}
